import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

export interface AppConfig {
  color: string;
}

@Injectable()
export class AppConfigService {
  private readonly http = inject(HttpClient);
  public static settings: AppConfig;

  public load(): Promise<void> {
    const jsonFile = 'app-config.json';

    return new Promise<void>((resolve) => {
      this.http
        .get(jsonFile)
        .toPromise()
        .then((response: any) => {
          AppConfigService.settings = response as AppConfig;
          resolve();
        })
        .catch(() => {
          AppConfigService.settings = {
            color: 'green',
          };
          resolve();
        });
    });
  }
}
